<template>
  <div class="col-md-12 d-flex profile-card">
    <!-- Address Details -->
    <div class="card card-table flex-fill card-details person-info add-details">
      <div class="person-profile">
        <h4>Address Details</h4>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="inform-content">
            <label>Address</label>
            <input type="text" class="form-control" />
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="inform-content">
            <label>Country</label>
            <input type="text" class="form-control" />
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="inform-content">
            <label>State / Province</label>
            <input type="text" class="form-control" />
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="inform-content">
            <label>City</label>
            <input type="text" class="form-control" />
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="inform-content">
            <label>Postal Code</label>
            <input type="text" class="form-control" />
          </div>
        </div>
      </div>
    </div>
    <!-- /Address Details -->
  </div>
</template>
